/**
 * 마작 게임 타일 유형 정의
 * 마작 게임에는 다양한 타일이 있으며, 이 파일에서는 게임에 사용될 타일 유형을 정의합니다.
 */

// 타일 유형 상수
export const TILE_TYPES = {
  // 수패(숫자 타일)
  DOT: 'dot', // 원 타일 (1-9)
  BAMBOO: 'bamboo', // 대나무 타일 (1-9)
  CHARACTER: 'character', // 문자 타일 (1-9)
  
  // 자패(영예 타일)
  WIND: 'wind', // 바람 타일 (동, 서, 남, 북)
  DRAGON: 'dragon', // 용 타일 (적, 녹, 백)
};

// 바람 방향 상수
export const WIND_DIRECTIONS = {
  EAST: 'east',
  SOUTH: 'south',
  WEST: 'west',
  NORTH: 'north',
};

// 용 색상 상수
export const DRAGON_COLORS = {
  RED: 'red',
  GREEN: 'green',
  WHITE: 'white',
};

// 타일 생성 함수
export const createTiles = () => {
  const tiles = [];
  
  // 수패(숫자 타일) 생성 - 각 종류별로 1-9까지, 각 숫자당 4개씩
  for (let i = 1; i <= 9; i++) {
    // 원 타일
    for (let j = 0; j < 4; j++) {
      tiles.push({
        type: TILE_TYPES.DOT,
        value: i,
        id: `dot-${i}-${j}`,
      });
    }
    
    // 대나무 타일
    for (let j = 0; j < 4; j++) {
      tiles.push({
        type: TILE_TYPES.BAMBOO,
        value: i,
        id: `bamboo-${i}-${j}`,
      });
    }
    
    // 문자 타일
    for (let j = 0; j < 4; j++) {
      tiles.push({
        type: TILE_TYPES.CHARACTER,
        value: i,
        id: `character-${i}-${j}`,
      });
    }
  }
  
  // 바람 타일 생성 - 동, 서, 남, 북 각각 4개씩
  Object.values(WIND_DIRECTIONS).forEach(direction => {
    for (let j = 0; j < 4; j++) {
      tiles.push({
        type: TILE_TYPES.WIND,
        value: direction,
        id: `wind-${direction}-${j}`,
      });
    }
  });
  
  // 용 타일 생성 - 적, 녹, 백 각각 4개씩
  Object.values(DRAGON_COLORS).forEach(color => {
    for (let j = 0; j < 4; j++) {
      tiles.push({
        type: TILE_TYPES.DRAGON,
        value: color,
        id: `dragon-${color}-${j}`,
      });
    }
  });
  
  return tiles;
};

// 타일 섞기 함수
export const shuffleTiles = (tiles) => {
  const shuffled = [...tiles];
  for (let i = shuffled.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
  }
  return shuffled;
};

// 타일 이미지 경로 가져오기 함수 - CSS 색상 기반 이미지 대체
export const getTileImagePath = (tile) => {
  if (!tile) return '';
  
  // 실제 이미지 파일 대신 CSS 색상 코드 반환
  // 이 값들은 Tile 컴포넌트에서 배경색으로 사용됨
  switch (tile.type) {
    case TILE_TYPES.DOT:
      return `#${(parseInt(tile.value) * 10 + 50).toString(16)}${(parseInt(tile.value) * 20 + 50).toString(16)}ff`;
    case TILE_TYPES.BAMBOO:
      return `#${(parseInt(tile.value) * 20 + 50).toString(16)}ff${(parseInt(tile.value) * 10 + 50).toString(16)}`;
    case TILE_TYPES.CHARACTER:
      return `#ff${(parseInt(tile.value) * 20 + 50).toString(16)}${(parseInt(tile.value) * 10 + 50).toString(16)}`;
    case TILE_TYPES.WIND:
      return tile.value === 'east' ? '#87ceeb' :
             tile.value === 'south' ? '#ff6347' :
             tile.value === 'west' ? '#9370db' :
             '#3cb371'; // north
    case TILE_TYPES.DRAGON:
      return tile.value === 'red' ? '#ff0000' :
             tile.value === 'green' ? '#00ff00' :
             '#ffffff'; // white
    default:
      return '#1a4d2e'; // 기본 배경색
  }
};

// 타일 텍스트 가져오기 함수 (이미지 대신 텍스트 표시)
export const getTileText = (tile) => {
  if (!tile) return '';
  
  switch (tile.type) {
    case TILE_TYPES.DOT:
      return `●${tile.value}`;
    case TILE_TYPES.BAMBOO:
      return `┃${tile.value}`;
    case TILE_TYPES.CHARACTER:
      return `文${tile.value}`;
    case TILE_TYPES.WIND:
      return tile.value === 'east' ? '東' :
             tile.value === 'south' ? '南' :
             tile.value === 'west' ? '西' :
             '北'; // north
    case TILE_TYPES.DRAGON:
      return tile.value === 'red' ? '中' :
             tile.value === 'green' ? '發' :
             '白'; // white
    default:
      return '?';
  }
};

export default {
  TILE_TYPES,
  WIND_DIRECTIONS,
  DRAGON_COLORS,
  createTiles,
  shuffleTiles,
  getTileImagePath,
  getTileText,
};
